import React, { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import { Profile } from '../../../../app/pages/Profile/Profile'


const AsideDefault: FC = () => {
  const { config, classes } = useLayout()
  const { aside } = config
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <div
        id='kt_aside'
        className={clsx('aside', classes.aside.join(' '))}
        data-kt-drawer='true'
        data-kt-drawer-name='aside'
        data-kt-drawer-activate='{default: true, lg: false}'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'200px', '300px': '250px'}"
        data-kt-drawer-direction='start'
        data-kt-drawer-toggle='#kt_aside_mobile_toggle'
      >
        {/* begin::Brand */}
        <div className='aside-logo flex-column-auto border-bottom border-gray' id='kt_aside_logo' style={{ height: '100px', overflow: 'auto' }}>
          {/* begin::Logo */}
          {aside.theme === 'dark' && (
            <Link to='/dashboard'>
              <img
                alt='Logo'
                className=' w-150px logo'
                src={toAbsoluteUrl('/media/logos/Group 178.svg')}
              />
            </Link>
          )}
          {aside.theme === 'light' && (
            <Link to='/dashboard'>
              <img
                alt='Logo'
                className='h-25px logo'
                src={toAbsoluteUrl('/media/logos/Causeway logo.svg')}
              />
            </Link>
          )}
          {/* end::Logo */}

          {/* begin::Aside toggler */}
          {aside.minimize && (
            <div
              id='kt_aside_toggle'
              className='btn btn-icon w-auto px-0 aside-toggle'
              data-kt-toggle='true'
              data-kt-toggle-state='active'
              data-kt-toggle-target='body'
              data-kt-toggle-name='aside-minimize'
            >
              <KTSVG
                path={'/media/icons/duotune/arrows/arr080.svg'}
                className={'svg-icon-1 rotate-180'}
              />
            </div>
          )}
          {/* end::Aside toggler */}
        </div>
        {/* end::Brand */}

        {/* begin::Aside menu */}
        <div className='aside-menu flex-column-fluid'>
          <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
        </div>
        {/* end::Aside menu */}

        {/* begin::Footer */}
        <div className='aside-footer flex-column-auto pt-5 pb-7 px-5' id='kt_aside_footer'>
          <div>
            {/* Profile Button (Opens Modal) */}
            <button
              onClick={() => setShowModal(true)}
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-dismiss="click"
              className="btn btn-custom w-100 mb-2"
              style={{ backgroundColor: '#C42A21' }}
            >
              <span className="btn-label" style={{ color: '#fff' }}>Profile</span>
              <span className="svg-icon btn-icon svg-icon-2">
                <img src={toAbsoluteUrl('/media/icons/duotune/communication/com006.svg')} alt="Profile" />
              </span>
            </button>

            {/* Logout Link */}
            <Link
              to="/logout"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-dismiss="click"
              className="btn btn-custom w-100"
              style={{ backgroundColor: '#D4DCE1' }}
            >
              <span className="btn-label" style={{ color: '#333' }}>Logout</span>
              <span className="svg-icon btn-icon svg-icon-2">
                <img src={toAbsoluteUrl('/media/icons/duotune/arrows/logout 2.svg')} alt="Logout" />
              </span>
            </Link>
          </div>
        </div>
        {/* end::Footer */}
      </div>

      {/* Profile Modal */}
      {/* {showModal && (
        <div className="modal-backdrop rounded-5">
          <div className="modal d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Profile</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <Profile /> 
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      <Profile
        isOpen={showModal}
        onClose={() => setShowModal(false)}

      />
    </>
  )
}

export { AsideDefault }
